// custom-header.js
document.addEventListener('DOMContentLoaded', () => {
  // --- Sticky Header Logic ---
  const headerWrapper = document.querySelector('.luxury-header-wrapper');
  if (headerWrapper && headerWrapper.classList.contains('luxury-header-sticky')) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        headerWrapper.classList.add('is-scrolled');
      } else {
        headerWrapper.classList.remove('is-scrolled');
      }
    });
  }

  // --- Localization Dropdowns Logic ---
  const dropdowns = document.querySelectorAll('.luxury-dropdown');
  
  dropdowns.forEach(dropdown => {
    const toggle = dropdown.querySelector('.luxury-dropdown__toggle');
    const menu = dropdown.querySelector('.luxury-dropdown__menu');

    if (toggle && menu) {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Close all other dropdowns
        dropdowns.forEach(other => {
          if (other !== dropdown) {
            const otherMenu = other.querySelector('.luxury-dropdown__menu');
            if (otherMenu) otherMenu.classList.remove('is-active');
          }
        });

        // Toggle current dropdown
        menu.classList.toggle('is-active');
        toggle.setAttribute('aria-expanded', menu.classList.contains('is-active'));
      });
    }
  });

  // Close dropdowns on outside click
  document.addEventListener('click', (e) => {
    dropdowns.forEach(dropdown => {
      const menu = dropdown.querySelector('.luxury-dropdown__menu');
      if (menu && menu.classList.contains('is-active') && !dropdown.contains(e.target)) {
        menu.classList.remove('is-active');
        dropdown.querySelector('.luxury-dropdown__toggle').setAttribute('aria-expanded', 'false');
      }
    });
  });

  // --- Mobile Menu Logic ---
  const mobileMenuBtn = document.querySelector('.luxury-header__menu-btn');
  const mobileDrawer = document.getElementById('mobile-menu-drawer');
  const mobileOverlay = document.querySelector('.luxury-drawer-overlay');
  const mobileCloseBtn = document.querySelector('.luxury-mobile-drawer__close');

  const openMobileMenu = () => {
    if (mobileDrawer && mobileOverlay) {
      mobileDrawer.classList.add('is-active');
      mobileOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
  };

  const closeMobileMenu = () => {
    if (mobileDrawer && mobileOverlay) {
      mobileDrawer.classList.remove('is-active');
      mobileOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  };

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', openMobileMenu);
  }

  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener('click', closeMobileMenu);
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }
});
